import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Расчет <Highlighted>аванса и объема поставки</Highlighted>',
  warning: {
    sign: '*',
    text: 'Предложение носит информационный характер и не является публичной офертой по ст.437 (2) ГК РФ. Все приведенные расчеты являются предварительными. Для получения точных условий обратитесь, пожалуйста, к менеджерам. Предложение носит информационный характер',
  },
} satisfies TMessages
